// REACT & REDUX
import React, { Component } from 'react';

// STYLE, PROPS & TRANSLATIONS
import '../../style/site.css';

import Upload from '../upload/Upload.container'

// COMMON

// COMPONENTS
import { Grid, GridItem, SpacerContainer } from "careconnect-ui";


// ACTIONS & API

// *************************************************************************************************************************************

export class Root extends Component {

    render() {
        return (
            <div>
                <SpacerContainer left="small" right="small">
                    <Grid>

                        <GridItem xs={12}>
                            <Upload />
                        </GridItem>
                    </Grid>
                </SpacerContainer>
            </div>
        );
    }
}